/* @flow */

/**
 * Liferay requests service
 * The HTTP requests are handled using https://github.github.io/fetch
 *  BEA
 */

import keys from 'config/keys';

import areas from './areas';
import broadcastings from './broadcastings';
import broadcastTypes from './broadcastTypes';
import cart from './cart';
import categories from './categories';
import channels from './channels';
import medias from './medias';
import producers from './producers';
import productions from './productions';
import productionTypes from './productionTypes';
import territories from './territories';
import tracks from './tracks';
import usageTypes from './usageTypes';
import usages from './usages';
import worklists from './worklists';
import smartlists from './smartlists';
import featured from './featured';
import purchases from './purchases';
import onDemand from './onDemand';

import utils from './utils';
import domUtils from '../../utils/dom';
import keycloak from '../keycloak';

import type { Endpoint } from 'types';

//$FlowFixMe

export const callApiEndpoint = async (
  endpoint: Endpoint,
  params: {
    method?: string,
    params?: { [string]: string },
    body?: any,
  } = {}
) => {
  const token = keycloak.token;
  const url = new URL(`${keys.API_BASE_URL}/v1/${endpoint}`);

  if (params.params)
    Object.keys(params.params).forEach(key => url.searchParams.append(key, params.params[key]));

  const response = await fetch(url, {
    method: params.method || 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: params.body ? JSON.stringify(params.body) : undefined,
  });
  if (!response.ok) {
    throw new Error(response.statusText || 'Connection error');
  }
  const responseBody = await response.json();
  if (responseBody.exception) {
    if (responseBody.message === 'Authenticated access required') {
      domUtils.refreshCurrentPage();
    }
    throw utils.toError(responseBody);
  }
  return responseBody;
};

export default {
  tracks,
  medias,
  categories,
  smartlists,
  featured,
  usages,
  worklists,
  producers,
  productions,
  cart,
  territories,
  usageTypes,
  areas,
  channels,
  broadcastings,
  broadcastTypes,
  productionTypes,
  purchases,
  onDemand,
};
